module.exports = __webpack_public_path__ + "img/BookmarkedIcon.21ba2835.svg";